import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react/index'
import { observable, computed, action } from 'mobx'
import PropTypes from 'prop-types'
import object_value from '../api/object_value'
import { NotificationManager } from 'react-notifications'

@inject('wishlist', 'user')
@observer
class WishlistButton extends Component {
  @observable wishlistDisabled = false

  @computed get isInWishlist() {
    const { wishlist, experience_id } = this.props
    let wishlist_experiences = object_value(wishlist, 'data.experiences')
    if (!wishlist_experiences || !experience_id) {
      return false
    }
    return !!wishlist_experiences.find(obj => {
      return obj.id.toString() === experience_id.toString()
    })
  }

  @action handleWishlistToggle = (event) => {
    if (this.wishlistDisabled) {
      return
    }
    event.preventDefault();
    // debugger
    const { user, experience_id, wishlist } = this.props
    if (!user.login) {
      console.log('handleWishlistToggle error: no `user.login`')
      return false
    }
    if (!user.token) {
      console.log('handleWishlistToggle error: no `user.token`')
      return false
    }
    this.wishlistDisabled = true
    // console.log('handleWishlistToggle isInWishlist:', this.isInWishlist)
    if (!this.isInWishlist) {
      wishlist.attach_experience(experience_id, user.token).then(this.actionSuccess, this.actionError)
    } else {
      wishlist.detach_experience(experience_id, user.token).then(this.actionSuccess, this.actionError)
    }
  }

  @action.bound
  actionSuccess (result) {
    // console.log('handleWishlistToggle success - result:', result)
    this.wishlistDisabled = false
  }

  @action.bound // callback action
  actionError (error) {
    console.log('handleWishlistToggle error:', error)
    this.wishlistDisabled = false
  }

  render () {
    const { user, wishlist, experience_id, get_class } = this.props

    if ( !user.login
      || !wishlist
      || !experience_id) {
      return (<div />)
    }

    return (
      <button className={!this.isInWishlist ? get_class : get_class + ' liked'}
              disabled={this.wishlistDisabled}
              onClick={this.handleWishlistToggle}>
      </button>
    )
  }
}

WishlistButton.defaultProps = {
  get_class: 'b-experiences-experience-liked'
}

WishlistButton.propTypes = {
  get_class: PropTypes.string,
  experience_id: PropTypes.string,
  user: MobxPropTypes.observableObject,
  wishlist: MobxPropTypes.observableObject
}

export default WishlistButton



// WEBPACK FOOTER //
// ./src/components/WishlistButton.js